import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../actions/userAction";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../../styles/contact.css";

const Contact = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { loading, error, userInfo } = userLogin;

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(login(name, email, message));
  };

  return (
    <div>
      <div className="herobg">
        <Header />
        <section className="container position-relative contact-hero pt-4">
          <div className="d-flex justify-content-between h-100 pt-3">
            <h2 className="font-heading py-1 lh-small font-weight-bolder text-white">
              Get In <span style={{ color: "#75e8f0" }}>Touch</span>
            </h2>
          </div>
        </section>
      </div>
      <section className="py-4 container contact-section">
        <div className="d-flex justify-content-center">
          {/* <div className="col-md-7 p-3" style={{ backgroundColor: "#fff" }}>
            <h4 className="font-normal mb-3 font-weight-bolder">
              Send us a message
            </h4>
            <form onSubmit={handleSubmit} className="w-100 contact-form">
              <div className="input mb-3">
                <input
                  type="text"
                  value={name}
                  placeholder="NAME"
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="input mb-3">
                <input
                  type="email"
                  value={email}
                  placeholder="EMAIL"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input mb-3">
                <textarea
                  value={message}
                  placeholder="MESSAGE"
                  onChange={(e) => setMessage(e.target.value)}
                  required></textarea>
              </div>
              <div className="my-2">
                <button
                  className="d-flex justify-content-center w-100 text-center py-50"
                  type="submit">
                  {loading ? <div className="spinner"></div> : "MESSAGE"}
                </button>
              </div>
            </form>
          </div> */}
          <div className="col-md-5 p-3 info d-flex align-items-center text-white">
            <div>
              <h4 className="font-normal mb-3 font-weight-bolder text-white">
                Contact Information
              </h4>
              <div>
                <div className="mb-1 font-sm">
                  <i class="fas fa-phone-alt mr-1"></i>
                  +234 810 121 1029
                </div>
                <div className="mb-1 font-sm">
                  <i class="fas fa-map-marker-alt mr-1"></i>
                  76 Dallas Texas House Road 246, USA
                </div>
                <div className="mb-1 font-sm">
                  <i class="fab fa-twitter mr-1"></i>
                  <i class="fab fa-facebook-f mr-1"></i>
                  <i class="fab fa-linkedin-in"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
